export const exerciseCardFeatures = [
  'Objetivo del ejercicio',
  'Material y montaje necesarios',
  'Posición inicial',
  'Movimiento y regreso',
  'Dosis y pausas',
  'Imagen de referencia',
  'Error frecuente (en rojo)',
  'Corrección (en verde)',
  'Una opción más sencilla',
  'Una progresión y criterio para el siguiente paso'
];
